
import { defineComponent,ref,Ref,ComputedRef,reactive, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { MobileOutlined,FileImageOutlined, FieldNumberOutlined, CheckCircleOutlined, UnlockOutlined } from '@ant-design/icons-vue'

import { Props, validateInfos } from 'ant-design-vue/lib/form/useForm'
import { message, Form } from 'ant-design-vue'
const useForm = Form.useForm

import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'

import {BindPhoneParamsType} from './data.d'

import {StateType as ImageCodeStateType} from '@/store/imageCode'
import {StateType as VerificStateType} from '@/store/verific'
import {StateType as UserStateType} from '@/store/user'
import {StateType as bindUserPhoneStateType} from './store'

import { VerificParams } from '@/services/data.d'

interface BindPhoneSetupData{
    t: (key: string | number) => string
    resetFields: (newValues?: Props) => void
    showflag: Ref<boolean>
    downflag: Ref<boolean>
    txtflag: Ref<boolean>
    count: Ref<number>
    validateInfos: ComputedRef<validateInfos>
    modelRef: BindPhoneParamsType
    imgUrl: Ref<string>
    typeStr: Ref<string>
    handleCtrl: (e: MouseEvent) => void
    handleSubmit: (e: MouseEvent) => void
    handleSendMsg: (e: MouseEvent) => void
    handleChangeIt: (e: MouseEvent) => void
}

export default defineComponent({
    name: 'Phone',
    props: {
        typeT: {
            type: String,
            default: ()=>{return ''}
        }
    },
    emits: ['update:visible','resClick'],
    components: {
        MobileOutlined,
        FileImageOutlined,
        FieldNumberOutlined,
        CheckCircleOutlined,
        UnlockOutlined
    },
    setup(props, {emit}): BindPhoneSetupData{
        const { t } = useI18n()
        const store = useStore<{
            imagecode: ImageCodeStateType,
            verific: VerificStateType,
            bindUserPhone: bindUserPhoneStateType,
            UserStateType: UserStateType
        }>()
        const showflag = ref<boolean>(true)
        const downflag = ref<boolean>(true)
        const txtflag = ref<boolean>(true)
        const count = ref<number>(60)
        const imgUrl = ref<string>('')
        const typeStr = ref<string>(props.typeT)
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const handleCtrl = (e: MouseEvent)=>{
            emit('update:visible',false)
            emit('resClick',true)
        }

        const handleSendMsg = (e:MouseEvent) => {
            const params = { phone: modelRef.phone }
            if(modelRef.phone == ''){
                message.warning(t('page.personal.center.compontent.phone.required'))
            }else{
                getVerificCode(params)
                txtflag.value = false
                downflag.value = false
                const t = setInterval(()=>{
                    if(count.value > 0){
                        count.value--
                    }else{
                        clearInterval(t)
                        count.value = 60
                        downflag.value = true
                    }
                },1000)
            }
        }

        const modelRef = typeStr.value !== 'phone' ? reactive<BindPhoneParamsType>({
            phone: '',
            code: '',
            phoneCode: ''
        }):reactive<BindPhoneParamsType>({
            phone: '',
            code: '',
            phoneCode: '',
            password: ''
        })
        const rulesRef = typeStr.value !== 'phone' ? reactive({
            phone: [
                {
                    required: true,
                    message: '请输入手机号码'
                }
            ],
            code: [
                {
                    required: true,
                    message: '请输入图形验证码'
                }
            ],
            phoneCode: [
                {
                    required: true,
                    message: '请输入短信验证码'
                }
            ],
        }) : reactive({
            phone: [
                {
                    required: true,
                    message: '请输入手机号码'
                }
            ],
            password: [
                {
                    required: true,
                    message: '请输入密码码'
                }
            ],
            code: [
                {
                    required: true,
                    message: '请输入图形验证码'
                }
            ],
            phoneCode: [
                {
                    required: true,
                    message: '请输入短信验证码'
                }
            ],
        })

        // 获取表单内容
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)

        const handleSubmit = async(e: MouseEvent) => {
            try {
                const fieldsValue = await validate<BindPhoneParamsType>()
                const email = userMsg?.email
                fieldsValue['smsCode'] = store.state.imagecode.codeMd5
                fieldsValue['email'] = email
                const res: boolean = typeStr.value !== 'phone' ?
                    await store.dispatch('bindUserPhone/bindUserPhoneFn',fieldsValue) :
                    await store.dispatch('bindUserPhone/changeUserPhoneFn',fieldsValue)
                if(res === true){
                    showflag.value = false
                    store.dispatch('user/fetchCurrent',{userCode: userMsg?.userCode})
                }
            } catch (error) {
                message.warning('绑定失败!')
            }


        }

        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        //获取图片验证码
        const getImageCode = async()=>{
            try {
                const res:boolean = await store.dispatch('imagecode/imageCode')
                if(res === true){
                    const img = store.state.imagecode.imgBase64
                    imgUrl.value = `data:image/png;base64,${img}`
                }
            } catch (error) {
                message.warning('获取图片失败')
            }
        }
        //换一换
        const handleChangeIt = (e:MouseEvent) => {
            e.preventDefault()
            getImageCode()
        }

        const getVerificCode = async(params:VerificParams) => {
            try {
                const res: boolean = await store.dispatch('verific/verificCode',params)
                if(res === true){
                    message.success('验证码已发送，请注意查收!')
                }
            } catch (error) {
                message.warning('')
            }
        }

        onMounted(()=>{
            getImageCode()
        })

        return {
            t,
            showflag,
            modelRef,
            txtflag,
            downflag,
            count,
            validateInfos:validateInfosNew,
            imgUrl,
            typeStr,
            resetFields,
            handleCtrl,
            handleSubmit,
            handleSendMsg,
            handleChangeIt
        }
    }
})
